import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from '../../api-entry-control.service';

@Component({
  selector: 'app-list-facility-supervisor',
  templateUrl: './list-facility-supervisor.component.html',
  styleUrls: ['./list-facility-supervisor.component.css']
})
export class ListFacilitySupervisorComponent implements OnInit {
  error: any;
  
  constructor(
    private api: ApiEntryControlService,
    private modal: NgbModal,
    private toast: ToastrService,
    private router: Router,
  ) { }

  view: number = 1;
  status: any;
  categorys: any;
  idSelected: number = 0;
  loading: boolean = false;
   Math = Math;
  
  ngOnInit(): void {
    this.getData();
  }

  items: any;
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  brands: any;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
  });

  delete() {
    this.api.deleteFacility(this.form).subscribe(
      (response) => {
        this.toast.success(
          'Instalacion y todas su dependencias fueron eliminadas',
          'Gestión instalaciones'
        );
        this.modal.dismissAll();
        this.getData();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.error.msg);
        this.getData();
      }
    );
  }

  goToView(id: number) {
    this.router.navigate(['supervisar-instalacion/' + id]);
  }

  getData() {
    this.loading = true;
    this.api.paginateFacilityExclusive(this.page).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items;
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;
        console.log(this.collectionSize);
        this.totalPage = data.total;
        this.loading = false;
      },
      (e) => {
        this.items = [];
        this.page = 1;
        this.loading = false;
      }
    );
  }

  openModal(md: any, size: string = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }

  openDelete(id: number, md: any) {
    this.form.get('id').setValue(id);
    this.modal.open(md, {
      size: 'md',
    });
  }

  search() {
    this.getData();
  }

  clean() { }

  // Métodos auxiliares para el template
  formatRut(rut: string): string {
    if (!rut) return '';
    // Formatear RUT con puntos y guión
    const rutNumbers = rut.replace(/[^0-9kK]/g, '');
    if (rutNumbers.length > 1) {
      const dv = rutNumbers.slice(-1);
      const number = rutNumbers.slice(0, -1);
      return number.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + dv;
    }
    return rut;
  }

  formatPhone(phone: string): string {
    if (!phone) return '';
    // Formatear teléfono chileno
    if (phone.length === 9 && phone.startsWith('9')) {
      return `+56 ${phone.substring(0, 1)} ${phone.substring(1, 5)} ${phone.substring(5)}`;
    }
    return phone;
  }

  getInitials(name: string): string {
    if (!name) return '';
    return name.split(' ')
      .map(word => word.charAt(0))
      .join('')
      .substring(0, 2)
      .toUpperCase();
  }
}